import React, { useEffect, useState } from 'react';
import { AdminModal } from '../../../components';
import { axiosInstance, formatDate } from '../../../utils';
import add from "../../../assets/svgs/add.svg";
import eye from "../../../assets/svgs/eye.svg";
import  { Link } from 'react-router-dom';
// import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";

const Admin = () => {
    const [open, setOpen] = useState(true);
    const [toggle, setToggle] = useState(false);
    const [data, setData] = useState([]); 
    const [selectAdmin, setSelectAdmin] = useState("");
    const [getAdminListData, setGetAdminListData] = useState([]);
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState(""); 
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);

   const navigate = useNavigate();

    const handleOpen = () => {
        setOpen(!open);
    }
    
    const onCancel = () => {
      setToggle(false);
    }

    const handleToggleModal = () => {
      setToggle(!toggle);
    }

      const token = localStorage?.getItem("token");

    useEffect(() => {
      getAdminList();
    }, []);

   
      const indexOfLastItem = 1 * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = data.slice(0, itemsPerPage);
   
 

    useEffect(() => {
      const token = localStorage.getItem("token");
      const getAdmins = async () => {
        
       await axiosInstance.get(`/api/admin/get-all-admins?page=${currentPage}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then(res => {
          setData(res.data?.data?.adminsList);
        })
        .catch(err => {
          toast.error(err.response.data.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
        })
      }
      getAdmins();
    }, [currentPage])

  
    const getAdminList = () => {
      axiosInstance.get(`/api/admin/get-admin-username-list`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      })
      .then(res => {
        
        setLoading(false);
        setGetAdminListData(res?.data?.data?.usernameList);
      })
      .catch(err => {
        toast.error(err.response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          });
      })
     }
  
     
    const handleAdminSelect = (e) => {
      setSelectAdmin(e.target.value);
    }
    
  
  
    const onApply = async () => {
      
      try {
        if(!fromDate) {
          toast.error("Please, select Start Date", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
        } else if(!toDate) {
          toast.error("Please, select End Date", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
        } else if(!selectAdmin) {
          toast.error("Please, select User name", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            });
        } else { 
  
          if(fromDate && toDate) {
            const fromDateVal = new Date(fromDate);
            const fromDateFormat = formatDate(fromDateVal);
            const toDateVal = new Date(toDate);
            const toDateFormat = formatDate(toDateVal)
          
            
        const bodyValues = {
          "fromDate": fromDateFormat,
          "toDate": toDateFormat,
          "username": selectAdmin
        };
  
       const response =  await axiosInstance.post(`/api/admin/search-all-admins?page=${currentPage}`,  bodyValues, {
        headers: {
          Authorization: `Bearer ${token}`
        }
       })
        const data = response.data;
        setData(data?.data?.adminsList);
      }
      }
      } catch (error) {
        toast.error(error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          });
    
      }
    }
  
    const onReset = () => {
      setFromDate("");
      setToDate("");
      setSelectAdmin("");
    }


   const onPrevious = () => {
     setCurrentPage((prev) => prev - 1);
  }

  const onNext = () => {
    setCurrentPage((prev) => 
      prev + 1
    );
  }

  return (
    <section className='container py-10'>
        <div className={`bg-white lg:w-full md:w-[500px] sm:w-[500px] xs:w-[400px] min-h-24 px-6 py-3 rounded-md  mb-6 border-t-8 border-t-primary-yellow-500`}>
            {/* <div className='flex justify-between items-center pb-4'>
                <div className='flex items-center gap-3 justify-start'>
                    <div className='relative'>
                        <input type='text' className='lg:w-[320px] sm:w-[320px] md:w-[320px] w-[230px] border-[1px] border-secondary-n-40 p-3 rounded-md outline-none' placeholder='Search' />
                        <div className='absolute right-0 top-0 rounded-md h-[49px] w-12 flex justify-center items-center bg-primary-yellow-500'>
                        <img src={search} alt='search' />
                        </div>
                    </div>
                    <button className='flex justify-center items-center rounded-md w-12 h-12 bg-primary-yellow-500' onClick={handleOpen}>   
                    <img src={filter} alt="filter" />
                 

                    </button>
                </div>
                <div className='relative lg:visible md:hidden sm:hidden hidden'>
                    <div className='absolute top-3 left-6'>
                   <img src={add} alt='add' />

                    </div>
                <button className='w-48 h-12 rounded-md bg-primary-yellow-500 text-white' onClick={handleToggleModal}>Add Admin</button>
                </div>
                <button className='h-12 w-12 flex justify-center items-center rounded-md bg-primary-yellow-500 lg:hidden md:visible sm:visible visible' onClick={handleToggleModal}> <img src={add} alt='add' /></button>
            </div> */}

         <div className={`space-y-5`}>
         <div className='relative pb-4'>
                    <div className='absolute top-3 left-6'>
                   <img src={add} alt='add' />

                    </div>
                <button className='w-48 h-12 rounded-md bg-primary-yellow-500 text-white' onClick={() => navigate("/dashboard/user-management/admin/add-new-admin")}>Add Admin</button>
                </div>
              
         <div className='flex flex-col gap-3'>
            <div className='flex items-center gap-3 lg:flex-row md:flex-col sm:flex-col flex-col'>
                <div className='flex flex-col gap-1'>
                    <label className='text-sm'>From date</label>
                     <input type='date' className='w-[290px] border-[1px] border-secondary-n-40 p-3 text-secondary-n-90 rounded-md outline-none placeholder:text-secondary-n-90' placeholder='dd/mm/yyyy' value={fromDate} onChange={(e) => setFromDate(e.target.value)} /> 
                   {/* <DatePicker className='w-[290px] border-[1px] border-secondary-n-40 p-3 text-secondary-n-90 rounded-md outline-none placeholder:text-secondary-n-90' placeholderText='select date' selected={fromDate} onChange={(date) => setFromDate(date)} dateFormat={"dd-MM-yyyy"} /> */}

                </div>
                <div className='flex flex-col gap-1'>
                    <label className='text-sm'>To date</label>
                    <input type='date' className='w-[290px] border-[1px] border-secondary-n-40 p-3 text-secondary-n-90 rounded-md outline-none placeholder:text-secondary-n-90' placeholder='dd/mm/yyyy' value={toDate} onChange={(e) => setToDate(e.target.value)} />
                    {/* <DatePicker className='w-[290px] border-[1px] border-secondary-n-40 p-3 text-secondary-n-90 rounded-md outline-none placeholder:text-secondary-n-90' placeholderText='select date' selected={toDate} onChange={(date) => setToDate(date)} dateFormat={"dd-MM-yyyy"} /> */}

                </div>
                <div className='flex flex-col gap-1'>
                    <label className='text-sm'>User Name</label>
                    <select className='w-[290px] border-[1px] border-secondary-n-40 p-[14px] text-secondary-n-90 rounded-md outline-none placeholder:text-secondary-n-90' value={selectAdmin} onChange={handleAdminSelect}>
                        <option value={""} selected >Select user name</option>
                        { loading ? (
                          <option>loading ...</option>
                        ) : (
                          <>
                        {getAdminListData?.map((data, index) => {
                          return (
                            <option key={index}>{data}</option>
                          )
                        })}
                          </>
                        ) }
                    </select>
                </div>
            </div>
            <div className='flex lg:justify-end md:justify-center sm:justify-center justify-center'>
                <div className='flex items-center gap-3'>
                    <button className='p-2 border-[1px] border-primary-yellow-500 bg-transparent text-primary-yellow-500 font-poppins text-sm font-medium rounded-md w-28' onClick={onReset}>Reset</button>
                    <button className='p-2 bg-primary-yellow-500  text-white font-poppins text-sm font-medium rounded-md w-28' onClick={onApply}>Apply</button>
                </div>
            </div>
          </div>
         </div>
        </div>

        <div className='bg-white min-h-[100px] rounded-md space-y-3 mb-6'>

<div className="w-full  rounded-md overflow-x-scroll mb-7">
  <table className="">
    <thead className="border-b-2 border-b-secondary-n-40">
      <tr>
        <th className="p-4">No</th>
        <th className="px-6 border-l-2 border-dashed border-x-secondary-n-40 whitespace-nowrap">User Type</th>
        <th className="px-6 border-l-2 border-dashed border-x-secondary-n-40">User ID</th>
        <th className="px-6 border-l-2 border-dashed border-x-secondary-n-40">Username</th>
        <th className="px-6 border-l-2 border-dashed border-x-secondary-n-40">Email</th>
        <th className="p-4 border-l-2 border-dashed border-x-secondary-n-40">Contact Number</th>
        <th className="px-6 border-l-2 border-dashed border-x-secondary-n-40">Status</th>
        <th className="px-6 border-l-2 border-dashed border-x-secondary-n-40">Action</th>
      </tr>
    </thead>
    <tbody>
      { currentItems.length === 0 ? (
        <tr>
        <td></td>
        <td></td>
        <td></td>
        <td className='whitespace-nowrap text-base font-poppins font-medium flex  items-center text-center'>No Data</td>
        <td></td>
        <td></td>
        <td></td>
      </tr>
      ) : (
        <>
        {currentItems?.map((result, index) => {
          return (
  
        <tr key={index}>
          <td className='text-center p-4'>{index + 1}</td>
          <td className='text-center border-l-2 border-dashed px-6'>{result?.userType}</td>
          <td className='text-center border-l-2 border-dashed px-6'>{result?.userId}</td>
          <td className='text-center border-l-2 border-dashed px-6 whitespace-nowrap'>{result?.username}</td>
          <td className='text-center border-l-2 border-dashed px-6'>{result?.email}</td>
          <td className='text-center border-l-2 border-dashed px-6 whitespace-nowrap'>{result?.contactNumber}</td>
          <td className='text-center border-l-2 border-dashed px-6'>
          <div className='bg-[#25CA711A] whitespace-nowrap rounded-xl max-w-min p-3 h-7 flex justify-center items-center'>{result?.status}</div>
          </td>
          <td className='border-l-2 border-dashed px-6'>
         <div className='flex items-center gap-1'>
          <Link to={`/dashboard/user-management/admin/${result?.userId}`}>
               <img src={eye} alt='eye' />
          </Link>
         {/* <img src={edit} alt='edit' /> */}
         </div>
          </td>
        </tr>
          )
        })}
        </>
      ) }
    </tbody>
  </table>
</div>
<div className='flex justify-end items-center pb-3 space-x-4 container'>
  <button 
  onClick={onPrevious}
  disabled={currentPage === 1}
  className={`p-2 font-poppins text-sm font-medium rounded-md w-28 ${currentPage === 1 ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-primary-yellow-500 text-white'}`}>
  
    Previous
    </button>
  <button    onClick={onNext}  
  disabled={indexOfLastItem > data.length}   
  className={`p-2 ${indexOfLastItem > data.length ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-primary-yellow-500 text-white'} font-poppins text-sm font-medium rounded-md w-28`}
                 
>
  Next
</button>
</div> 
</div>

   { toggle && <AdminModal cancel={onCancel} /> }
   <ToastContainer />
    </section>
  )
}

export default Admin